import controller from './billfold.controller';
import template from './billfold.view.html';

let BillfoldComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default BillfoldComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/reports/billfold/billfold.component.js
 **/